import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ShippingAccountingRepository } from '../interfaces/shipping-accounting-repository.interface';
import { ShippingAccountingList } from '../models/shipping-accounting-list.model';

@Injectable()
export class GetShippingAccountingUseCase {
  constructor(private readonly repository: ShippingAccountingRepository) {}

  execute(query: string): Observable<ShippingAccountingList> {
    return this.repository.getList(query);
  }
}
